module.exports = __webpack_public_path__ + "img/15.9c3f058e.jpeg";